var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, observable } from 'mobx';
import { getProjectPartner as getProjectPartnerAction } from '@gtintel/platform-api';
let PartnerStore = (_class = class PartnerStore {
  constructor(rootStore) {
    this.rootStore = void 0;
    _initializerDefineProperty(this, "selectedPartner", _descriptor, this);
    _initializerDefineProperty(this, "projectPartner", _descriptor2, this);
    this.rootStore = rootStore;
  }
  async setSelectedPartner(selectedPartner) {
    this.selectedPartner = selectedPartner;
  }
  async getProjectPartner(projectId) {
    this.projectPartner = await getProjectPartnerAction(projectId);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "selectedPartner", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "projectPartner", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "setSelectedPartner", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedPartner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getProjectPartner", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getProjectPartner"), _class.prototype), _class);
export default PartnerStore;